export default "__VITE_ASSET__e88967b2__"